var map = {
	"./Bab1.webp": 9216,
	"./Bab10.webp": 6392,
	"./Bab11.webp": 635,
	"./Bab12.webp": 7994,
	"./Bab13.webp": 1349,
	"./Bab14.webp": 3492,
	"./Bab15.webp": 7527,
	"./Bab16.webp": 1910,
	"./Bab17.webp": 1665,
	"./Bab18.webp": 6224,
	"./Bab19.webp": 67,
	"./Bab2.webp": 8397,
	"./Bab20.webp": 4067,
	"./Bab21.webp": 4672,
	"./Bab22.webp": 4733,
	"./Bab23.webp": 2818,
	"./Bab24.webp": 4255,
	"./Bab25.webp": 6012,
	"./Bab26.webp": 5689,
	"./Bab27.webp": 1006,
	"./Bab28.webp": 3883,
	"./Bab3.webp": 7330,
	"./Bab4.webp": 6335,
	"./Bab5.webp": 1452,
	"./Bab6.webp": 5721,
	"./Bab7.webp": 9694,
	"./Bab8.webp": 8651,
	"./Bab9.webp": 280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9882;